import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { trainingsApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { Tab, TabsMenu } from "../../../UI/TabsMenu";
import TrainingsList from "./TrainingsFilter";
import classes from "./TrainingsPage.module.css";

const trainingsTypesEnum = {
    pedagogical: "pedagogical",
    system: "system"
}

const TrainingsPage = ({ view }) => {

    const { texts, lang } = useSelector(state => state.translate);
    const applicationId = useSelector(state => state.application.applicationId);

    const [trainings, setTrainings] = useState(null);
    const componentMounted = useRef(true);
    const dispatch = useDispatch();

    useEffect(() => {
        const trainingsFilter = {
            applicationId: applicationId,
            lang: view ? lang : null
        }
        trainingsApi.trainingsFilterRangePost({ trainingsRangeFilter: trainingsFilter }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.genralErrorMessage, error: error, statusCode: response?.statusCode, message: "genralErrorMessage " + error.message, level: 2, component: "TrainingsPage", line: 16 }))
            } else {
                if (componentMounted.current) {
                    setTrainings(resdata.map(t => {
                        const parse = JSON.parse(t.contentData ?? "{}");
                        return { ...t, type: parse.type }
                    }));
                }
            }
        })
    }, [])

    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    return <div className={classes.TrainingsPage}>
        <TabsMenu contentHeight={"calc(100vh - 350px)"}>
            <Tab name={`${texts.guidance} ${texts.pedagogical}`}>
                <TrainingsList type={trainingsTypesEnum.pedagogical} view={view} setTrainings={setTrainings} trainings={trainings} />
            </Tab>
            <Tab name={`${texts.guidance} ${texts.system}`}>
                <TrainingsList type={trainingsTypesEnum.system} view={view} setTrainings={setTrainings} trainings={trainings} />
            </Tab>
        </TabsMenu>
    </div>
}
export default TrainingsPage;